import { useEffect } from 'react';
import useSWR from 'swr';

type ParamType = {
  eventName: string;
  listener: (...args: any) => void;
};

export default function useE2Etest(list: ParamType[]) {
  const { data } = useSWR('global://e2e-test');

  const init = () => {
    if (!!data?.isReady) {
      list.forEach(({ eventName, listener }) => {
        (window as any).eventEmitter.on(eventName, listener);
      });

      return () => {
        list.forEach(({ eventName, listener }) => {
          (window as any).eventEmitter.off(eventName, listener);
        });
      };
    }
  };
  useEffect(init, [data]);
}
